import type { ReviewSchedule } from "../types/pgd.types";

export interface TreatmentPlanDates {
  supplyDate: string;
  nextQuestionnaireDueDate: string;
  nextSupplyDueDate: string;
  nextDrugSpecificReviewDueDate: string;
  drugSpecificReviewLabel: string;
  nextSectionBReviewDueDate: string;
  isInTitrationPhase: boolean;
  appliedSupplyIntervalDays: number;
}

export interface CalculateTreatmentPlanDatesInput {
  actualSupplyDate: string;
  initialSupplyDate: string;
  currentWeek: number;
  reviewSchedule: ReviewSchedule;
}

function addDays(isoDate: string, days: number): string {
  const date = new Date(isoDate);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().split("T")[0]!;
}

export function calculateTreatmentPlanDates(
  input: CalculateTreatmentPlanDatesInput,
): TreatmentPlanDates {
  const { actualSupplyDate, initialSupplyDate, currentWeek, reviewSchedule } = input;

  const isInTitrationPhase =
    reviewSchedule.titrationSchedule !== undefined &&
    currentWeek <= reviewSchedule.titrationSchedule.weeklyUntilWeek;

  const appliedSupplyIntervalDays = isInTitrationPhase
    ? reviewSchedule.titrationSchedule!.weeklyIntervalDays
    : reviewSchedule.supplyIntervalDays;

  const nextSupplyDueDate = addDays(actualSupplyDate, appliedSupplyIntervalDays);

  const questionnaireDaysBeforeSupply = Math.max(1, appliedSupplyIntervalDays - 7);
  const nextQuestionnaireDueDate = addDays(actualSupplyDate, questionnaireDaysBeforeSupply);

  const nextDrugSpecificReviewDueDate = addDays(
    initialSupplyDate,
    reviewSchedule.drugSpecificReviewDays,
  );

  const nextSectionBReviewDueDate = addDays(
    initialSupplyDate,
    reviewSchedule.sectionBReviewDays,
  );

  return {
    supplyDate: actualSupplyDate,
    nextQuestionnaireDueDate,
    nextSupplyDueDate,
    nextDrugSpecificReviewDueDate,
    drugSpecificReviewLabel: reviewSchedule.drugSpecificReviewLabel,
    nextSectionBReviewDueDate,
    isInTitrationPhase,
    appliedSupplyIntervalDays,
  };
}
